<template>
  <div class="edit-search" :class="{ desktop: $isDesktop }">
    <pu-campsite-availability-link
      v-bind="puCampsiteAvailabilityLinkProps"
      :data-sctrack="`${String($route.name)}--EditSearchButton-edit-search`"
      id="CheckAvailabilityPanel"
      class="edit-search-button button"
    >
      <span class="action"
        ><img
          loading="lazy"
          src="@/assets/images/magnify.svg"
          alt=""
          width="25"
          height="25"
        /><translate>Edit your search criteria...</translate>
      </span>

      <div class="search-criteria">
        <span class="losenge dates">
          <i18n-t keypath="{fromDate} - {toDate}">
            <template #fromDate>
              <pu-utc-date :date="dateRange.start" options="dayMonth" />
            </template>

            <template #toDate>
              <pu-utc-date :date="dateRange.end" options="dayMonth" />
            </template> </i18n-t
          >,&nbsp;<translate class="nights" :tt="{ nights: dateRangeNights }"
            >{nights, plural, one{# night} other{# nights}}</translate
          >
        </span>
        <campsite-party
          :party="party"
          :min-adult-age="minAdultAge"
          class="losenge"
        />
      </div>
    </pu-campsite-availability-link>
  </div>
</template>

<script lang="ts">
import { DateRange } from '~/utility/date/DateRange'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'
import { PuCampsiteAvailabilityLinkProps } from '../../pu-links/link-campsite/PuCampsiteAvailabilityLinkProps'
import { Party } from '../types'

@Component
class EditSearchButton extends Vue {
  @Prop({ required: true })
  dateRange: { start: string; end: string }

  @Prop({ required: true })
  party: Party

  @Prop({ required: true })
  minAdultAge: number

  @Prop({ required: true })
  campsiteSlug: string

  get dateRangeNights() {
    const { start, end } = this.dateRange
    return new DateRange(start, end).nights
  }

  get puCampsiteAvailabilityLinkProps(): Partial<PuCampsiteAvailabilityLinkProps> {
    return {
      slug: this.campsiteSlug,
    }
  }
}

export default toNative(EditSearchButton)
</script>
<style scoped>
.edit-search {
  padding: 1em 0.8em 0.5em;
  display: flex;
  justify-content: center;
}

.edit-search-button {
  background: white;
  border-bottom: none;
  border-radius: 0.6em;
  box-shadow: none;
  display: block;
  padding: 1em 1em 0.7em;
}

.edit-search-button a {
  text-decoration: none;
}

.action {
  font-weight: bold;
  display: block;
  margin: 0 0 0.5em;
}

.action img {
  width: 1.4em;
  margin-right: 0.25em;
}

.search-criteria {
  align-items: stretch;
  column-gap: 1em;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  row-gap: 0.4em;
}

.losenge {
  align-items: center;
  background: var(--colour-mid-green);
  border-radius: 0.35em;
  color: white;
  display: flex;
  flex-shrink: 1;
  font-size: var(--body);
  padding: 0.25em 0.35em;
  text-decoration: none;
  margin: 0 0 0.3em 0;
}

.campsite-party.losenge {
  flex-direction: column;
}

.campsite-party :deep(.converted-ages) {
  font-size: var(--small);
  margin: 0.4em 0 0.1em;
  display: block;
}

.campsite-party :deep(.dogs) {
  display: inline-block;
}

.search-criteria :deep(strong) {
  font-weight: normal;
}

.nights {
  display: inline-block;
}

/* desktop & tablet */
.edit-search.desktop {
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
}
</style>
